import React from 'react';
import displayData from '../fakeData/displayData/displayData';
import Place from '../Place/Place';
import './Home.css';

const Home = () => {
    const homeData = [...displayData];
    return (
        <div className="d-flex">
            {
                homeData.map(place => <Place place={place} key={place.id} />)
            }
        </div>
    );
};

export default Home;